export default __webpack_public_path__ + "locales/lv/ChangeEmailDialog.json?hash=012256c56762e6fc36bcf78405e513f5";